import { createApp } from "vue";
import GLightbox from 'glightbox';

// Swiper
import { register } from "swiper/element-bundle";
register();

import LocomotiveScroll from 'locomotive-scroll';
window.locomotiveScrollInstance = new LocomotiveScroll();

// import AtomShare from './vue/AtomShare.vue';

import Utils from "./general/utils.js";
import Header from "./components/header";
import ProjectCategorySlider from "./components/project-category-slider";
import Animations from "./components/animations";
import EmployeePhotoStrip from "./components/employee-photo-strip";

var utils = new Utils();
const header = new Header();
const projectCategorySlider = new ProjectCategorySlider();
const animations = new Animations();

window.glightbox = GLightbox({
  selector: 'a[href*="youtube.com/watch"], a[href*="vimeo.com"]:not(.SiteFooter__social a), a[href*="youtu.be"], .glightbox',
  width: 900,
  autoplayVideos: true,
  slideEffect: "fade",
});

document.querySelectorAll('.entry-content > .wp-block-cb-carousel').forEach((el) => {
  el.classList.add('escape-entry-content-width');
});
